// extracted by mini-css-extract-plugin
module.exports = {"container":"_3ldgl","loader":"GG97i"};